import React from "react";
import { Link } from "react-router-dom";
import logoBlack from "../../images/logos/logo-sub-white.png";
import logoWhite from "../../images/logos/logo-sub-black.png";
import ToggleTheme from "../themeToggle/ThemeToggle";
import Facebook from "../Socials/Facebook";
import Youtube from "../Socials/Youtube";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = ({ isDark, onToggleDark }) => {
  const logo = isDark ? logoBlack : logoWhite;

  return (
    <footer className="footer footer--bg footer--styleOne pt-50 pb-20">
      <div className="container">
        <div className="row align-items-center">
          {/* Лого */}
          <div className="col text-start">
            <div className="footer__logo">
              <img src={logo} alt="mcc" className="footer__logo__image" />
            </div>
          </div>

          {/* Social links */}
          <div className="col text-end">
            <div className="footer__social itSocial">
              <ul>
                <li>
                  <Facebook ClickHandler={ClickHandler} />
                </li>
                {/* <li>
                  <Link
                    onClick={ClickHandler}
                    className="instagram"
                    to="/"
                    rel="nofollow"
                  >
                    <i className="fab fa-instagram"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={ClickHandler}
                    className="linkedin"
                    to="/"
                    rel="nofollow"
                  >
                    <i className="fab fa-telegram"></i>
                  </Link>
                </li> */}
                <li>
                  <Youtube showI ClickHandler={ClickHandler} />
                </li>
              </ul>
            </div>
          </div>

          <div className="col-12">
            <hr className="footer__line" />
          </div>
        </div>

        {/* Доод хэсгийн цэс */}
        <div className="row">
          <div className="footer__middle pt-25 pb-25">
            <div className="row justify-content-between">
              <div className="footer__widget">
                <div className="footer__title text-center">
                  <h2 className="footer__heading text-uppercase ">
                    Хурдан холбоос
                  </h2>
                </div>
                <div className="footer__menu">
                  <ul>
                    <li>
                      <Link onClick={ClickHandler} to="/">
                        Нүүр хуудас
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/taniltsuulga">
                        Бидний танилцуулга
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/bidentei-holbogdoh">
                        Холбоо барих
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/sain-dur">
                        Сайн дурын үйл ажиллагаа
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Зохиогчийн эрх */}
        <div className="row">
          <div className="footer__bottom">
            <div className="row">
              <div className="col-12">
                <hr className="footer__line" />
              </div>
              <div className="col mb-10 pt-10 text-center">
                <div className="footer__copyright pt-20">
                  <p className="footer__copyright__text mb-0">
                    Зохиогчийн эрх @МонголСувдСүм {new Date().getFullYear()},
                    <br /> Бүх эрх хуулиар хамгаалагдсан <br />
                    МХХАлба
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col text-center">
        <ToggleTheme isChecked={isDark} handleChange={onToggleDark} />
      </div>
    </footer>
  );
};

export default Footer;
